import { useState } from 'react';

function getSliderPosition(isNavigationVisible: boolean, sliderItemWidth: number, activeItem: number): number {
	if (!isNavigationVisible) return 0;
	return activeItem * (-1 * sliderItemWidth);
}

export function useSlider(
	isNavigationVisible: boolean,
	sliderItemWidth: number,
	activeIndex: number,
	itemLength: number,
) {
	const [activeItem, setActiveItem] = useState(activeIndex > -1 ? activeIndex : 0);
	const [moveSliderLeftPosition, setMoveSliderLeftPosition] = useState(0);
	const [hasNavigation, setHasNavigation] = useState(isNavigationVisible);
	const getSliderLeftPosition = (active: number) => getSliderPosition(isNavigationVisible, sliderItemWidth, active);
	const slideBack = () => {
		if (activeItem <= 0) return;

		const newActiveItem = activeItem - 1;
		setActiveItem(newActiveItem);
		setMoveSliderLeftPosition(getSliderLeftPosition(newActiveItem));
	};
	const slideNext = () => {
		if (activeItem >= itemLength - 1) return;

		const newActiveItem = activeItem + 1;
		setActiveItem(newActiveItem);
		setMoveSliderLeftPosition(getSliderLeftPosition(newActiveItem));
	};
	const moveSliderToIndex = (index: number) => {
		setMoveSliderLeftPosition(getSliderLeftPosition(index));
	};

	return {
		activeItem,
		moveSliderLeftPosition,
		hasNavigation,
		setActiveItem,
		moveSliderToIndex,
		slideBack,
		slideNext,
		getSliderLeftPosition: () => getSliderLeftPosition(activeItem),
		setHasNavigation,
	};
}
